import { useNavigate } from "react-router-dom";
import { VIP_HERO_PHOTO } from "../lib/assets";
import { useReservationModal } from "../contexts/ReservationModalContext";

const HIGHLIGHTS = [
  { label: "VIP Tables", desc: "Premium reserved booths with dedicated table service." },
  { label: "Bottle Service", desc: "From classic champagne to high-end reserves." },
  { label: "Birthdays", desc: "Curated celebrations, sparklers & custom packages." },
  { label: "Corporate Events", desc: "Private buyouts & branded experiences." },
];

export default function VipTeaser() {
  const navigate = useNavigate();
  const { open: openReservation } = useReservationModal();
  return (
    <section data-testid="vip-teaser" className="relative py-28 md:py-40 bg-ink text-white overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-40">
        <img
          src={VIP_HERO_PHOTO}
          alt="VIP"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
      </div>

      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <span className="eyebrow" style={{ color: "var(--onyx-gold-soft)" }}>— VIP Experience</span>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl mt-6 mb-6 leading-[0.95]">
            Reserved for those who<br /><span className="text-[var(--onyx-gold)]">demand more.</span>
          </h2>
          <p className="text-white/65 max-w-lg leading-relaxed mb-10">
            From bespoke bottle parades and celebrity birthdays to corporate buyouts, the Onyx VIP team
            curates moments that go far beyond a typical night out.
          </p>
          <div className="flex flex-wrap gap-3">
            <button data-testid="vip-cta-reserve" onClick={() => openReservation()} className="btn-luxe btn-luxe-gold">Reserve VIP Table</button>
            <button data-testid="vip-cta-learn" onClick={() => navigate("/vip")} className="btn-luxe" style={{ borderColor: "rgba(255,255,255,0.4)", color: "#fff" }}>Learn More</button>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-px bg-white/10">
          {HIGHLIGHTS.map((h, i) => (
            <div key={i} data-testid={`vip-highlight-${i}`} className="bg-[#0A0A0A]/80 backdrop-blur-sm p-8 md:p-10">
              <div className="font-display text-4xl text-[var(--onyx-gold)] mb-4">0{i + 1}</div>
              <h4 className="font-display text-2xl mb-2">{h.label}</h4>
              <p className="text-sm text-white/55">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
